import { IconButton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router'
import { USER_ROLES } from '../../../utils/constant';
import { setAppliedFundsFilters } from '../../../redux-store/actions/investorProfile';
import { isRMLikeRole } from '../../../utils/utilityFunctions';

export default function CategoryCard({ data }: { data: any }): JSX.Element {
    const { role = "" } = useSelector((state: any) => state.auth);
    const { investorClientId = "" } = useSelector((state: any) => state.id);
    const history = useHistory();
    const { pathname: pathName, state } = history.location;
    const navState = state as { clientCode?: string };
    const { appliedFundsFilters } = useSelector((state: any) => state.investorProfile);
    const dispatch = useDispatch();

    const handleCategoryClick = () => {
        const checkFund = appliedFundsFilters.filter((item: any) => item?.filterTypeValue === data?.value?.filterTypeValue);
        if (checkFund?.length > 0) {
            history.push(`${pathName}/selected-category-funds`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId,
                ...(data?.label === "NFO" && { selectedCategory: "NFO" }),
            })
        }
        else {
            dispatch(setAppliedFundsFilters([...appliedFundsFilters, data?.value]));
            history.push(`${pathName}/selected-category-funds`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId,
                category: data?.key,
                ...(data?.label === "NFO" && { selectedCategory: "NFO" }),
            })
        }


    }
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            justifyContent: 'center',
            borderRadius: '8px',
            '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: '2px',
            }
        }}
            role="button"
            tabIndex={0}
            onClick={handleCategoryClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleCategoryClick();
                }
            }}
        >
            {/* {data?.icon} */}
            <img src={`${data?.icon}.svg`} alt={`${data?.label}`} />
            <Typography variant='body_500' color='text.secondary' mt={1}>
                {data?.label}
            </Typography>
        </Box>
    )
}
